'use client'

let vitalsEnabled = false

/** Own bootstrap state only; the SDK still owns individual session sampling. */
export function setRumVitalsEnabled(enabled: boolean): void {
  vitalsEnabled = enabled
}

export function areRumVitalsEnabled(): boolean {
  return vitalsEnabled
}
